import React, { createContext, useState, useContext, useCallback } from 'react';
import { chatsApi, metaApi } from 'api';
import toast from 'react-hot-toast';

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [currentCampaign, setCurrentCampaign] = useState(null);
  const [loadingCampaign, setLoadingCampaign] = useState(false);

  const fetchCampaign = useCallback(async (sessionId) => {
    if (!sessionId) return;
    setLoadingCampaign(true);
    try {
      const { data } = await chatsApi.getCampaign(sessionId);
      const catalogID = data.meta_settings?.advantage_plus?.catalog_id;
      if (catalogID) {
        try {
          const { data: catalogData } = await metaApi.getCatalog(catalogID);
          data.catalog = catalogData;
        } catch (catalogError) {
          console.error('Error fetching catalog:', catalogError);
          data.catalog = null;
        }
      }
      setCurrentCampaign(data);
      return data;
    } catch (error) {
      if (error.response.status === 404) {
        setCurrentCampaign(null);
        return null;
      }
      console.error('ChatContext: Error fetching campaign:', error);
      toast.error('Error al cargar la campaña');
      return null;
    } finally {
      setLoadingCampaign(false);
    }
  }, []);

  const clearCampaign = useCallback(() => {
    setCurrentCampaign(null);
  }, []);

  return (
    <ChatContext.Provider
      value={{
        currentCampaign,
        loadingCampaign,
        fetchCampaign,
        clearCampaign,
        setCurrentCampaign
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
}; 